import { EAccessCodeStatus } from 'features/AccessManagement/hooks/useOrganizationFormData'
import { Nullish } from './common.types'
import { Organization } from './organization.types'
import { UserInfoInOrganization } from './user.types'

export enum EAccessCodeType {
  institutionAccessCode = 'institutionAccessCode',
  promoCode = 'promoCode',
}

// Different models on backend for create and edit. Need to refactor after backend changes
export interface BaseAccessCode {
  code?: string
  codeType: EAccessCodeType
  reason: string
  organizationId?: number
  organizationName?: string
  status?: EAccessCodeStatus
  organizationType?: string
  organizationTwoDigits?: string
  twoDigitsOrg?: string
  organizationSingleLetter?: string
  singleLetterOrg?: string
  effectiveDate?: string | null
  expiryDate?: string | null
  specificState: string
  state?: string
  specificUnitName: string
  specificTwoDigits: string
  twoDigitsSpecific?: string
  duration: string
  numberOfUsers: number
  id?: number
  ownerId?: number
  ownerFirstName?: string
  ownerLastName?: string
  ownerEmail?: string
  regionalManagerId?: number
  regionalManagerFirstName?: string
  regionalManagerLastName?: string
  regionalManagerEmail?: string
  facilityManagerId?: number
  facilityManagerFirstName?: string
  facilityManagerLastName?: string
  facilityManagerEmail?: string
  supervisorId?: number
  supervisorFirstName?: string
  supervisorLastName?: string
  supervisorEmail?: string
}

export interface DraftUser {
  firstName: string
  lastName: string
  email: string
}

export interface AccessCode extends BaseAccessCode {
  code: string
  organization?: Organization
  draftOwner: DraftUser
  draftRegionalManager: DraftUser
  draftFacilityManager: DraftUser
  draftSupervisor: DraftUser
}

export interface AccessCodeDropdownItem {
  id: number
  code: string
  state: string
  unit: string
  specificUnitName: string
  specificState: string
}

export interface AccessCodeInOrganization {
  id: number
  code: string
  specificState: string
  specificUnitName: string
  specificTwoDigits: string
  owner: Nullish<UserInfoInOrganization>
  regionalManager: Nullish<UserInfoInOrganization>
  facilityManager: Nullish<UserInfoInOrganization>
  supervisor: Nullish<UserInfoInOrganization>
}

export interface AccessCodeWithManagers {
  id: number
  ownerId?: Nullish<number>
  regionalManagerId?: Nullish<number>
  facilityManagerId?: Nullish<number>
  supervisorId?: Nullish<number>
}

export interface UpdateAccessCodeWithManagersRequest {
  accessCodes: AccessCodeWithManagers[]
}
